<template>
  <div class="flex flex-col justify-center items-center">
    <div class="block p-10 w-full text-start max-w-sm bg-white rounded-lg border border-gray-200 shadow-mddark:bg-gray-800 dark:border-gray-700">
      <h5 class="mb-4 text-center text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Sign up</h5>
      <form @submit.prevent="handleRegister">
        <div class="mb-6">
          <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your email</label>
          <input v-model="user.email" type="email" id="email" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
        </div>
        <div class="mb-6">
          <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Your password</label>
          <input v-model="user.password" type="password" id="password" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
        </div>
        <div class="mb-6">
          <label for="confirmPassword" class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Confirm password</label>
          <input v-model="confirmPassword" type="password" id="confirmPassword" class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light" required>
        </div>
        <div class="flex items-start mb-6">
          <div class="flex items-center h-5">
            <input v-model="cbConditionsPrivacyService" id="terms" aria-describedby="terms" type="checkbox" class="w-4 h-4 bg-gray-50 rounded border border-gray-300 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800" required>
          </div>
          <div class="ml-3 text-sm">
            <label for="terms" class="font-medium text-gray-900 dark:text-gray-300">{{$t('i_agree_conditions_privacy_service')}} <a href="/general-terms-conditions" target="_blank" class="text-blue-600 hover:underline dark:text-blue-500">terms & conditions</a> and <a href="/terms-of-service" target="_blank" class="text-blue-600 hover:underline dark:text-blue-500">terms of service</a></label>
          </div>
        </div>
        <div class="flex items-start mb-6">
          <div class="flex items-center h-5">
            <input v-model="user.updates" id="updates" aria-describedby="updates" type="checkbox" class="w-4 h-4 bg-gray-50 rounded border border-gray-300 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800">
          </div>
          <div class="ml-3 text-sm">
            <label for="updates" class="font-medium text-gray-900 dark:text-gray-300">{{$t('i_want_to_receive_updates_emails')}}</label>
          </div>
        </div>
        <div class="mb-6">
          <template>
            <vue-recaptcha @verify="captcha = !captcha" sitekey="6Ld3vtgeAAAAAGk6KiP7ZZe0aR_uk-2t0lKa3Wnq"></vue-recaptcha>
          </template>
        </div>
        <div class="validationError mb-6">
          <span v-for="error in errors" :key="error" v-html="error" class="text-sm font-medium text-gray-900 dark:text-gray-400"></span>
        </div>
        <div class="mb-4 text-center">
          <button v-if="!loading" :disabled="loading" type="submit" class="w-full text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Register new account</button>
          <button v-else :disabled="loading" type="submit" class="opacity-50 cursor-auto w-full text-white bg-blue-700 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700">Register new account</button>
        </div>
        <div class="text-center">
          <span class="text-sm font-medium text-gray-900 dark:text-gray-400">Already registered? <a @click="goToLogin">Sign In</a></span>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha';

export default {
  name: 'Register',
  components: { VueRecaptcha },
  data() {
    return {
      user: {
        email: '',
        password: '',
        updates: false,
        ref: '',
        locale: '',
        timezone: ''
      },
      confirmPassword: '',
      cbConditionsPrivacyService: false,
      cbReceiveUpdatesEmails: false,
      captcha: false,
      loading: false,
      message: '',
      errors: []
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    
  },
  mounted() {
    if (this.loggedIn) {
      this.$router.push('/');
    }
  },
  methods: {
    handleRegister() {
        this.errors = [];
        if(this.user.email === ''){
          this.errors.push("- Email must be given(*)<br>");
        }else if(!this.validEmail(this.user.email)){
          this.errors.push("- Email must be valid(*)<br>");
        }
        if(this.user.password === ''){
          this.errors.push("- Password must be given(*)<br>");
        }else if(!this.validPassword(this.user.password)){
          this.errors.push("- Password should include minimum eight characters;<br>at least one upper case letter, <br>at least one lower case letter, <br>at least one digit, <br>at least one special character(*)<br>");
        }
        if(this.confirmPassword === ''){
          this.errors.push("- Confirm Password must be given(*)<br>");
        }else if(this.user.password !== this.confirmPassword){
          this.errors.push("- Password and Confirm Password must be equal(*)<br>");
        }
        if(!this.cbConditionsPrivacyService){
          this.errors.push("- Terms & Conditions, Privacy Policy and Terms of Service must be agreed(*)<br>");
        }
        if(!this.captcha){
          this.errors.push("- Captcha must be checked(*)<br>");
        }
        
        if(this.errors.length === 0)
        {
          this.loading = true;
          this.user.ref = this.$route.query.ref;
          this.user.locale = Intl.DateTimeFormat().resolvedOptions().locale;
          this.user.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          
          this.$store.dispatch('auth/register', this.user).then(
            (response) => {
              if(response.success === '1')
              {
                if(this.$route.query.redirect !== undefined)
                {
                  if(this.$route.query.redirect === 'UploadPage')
                  {
                    this.$router.push({
                      name: this.$route.query.redirect,
                      query: {
                        selectedIndex: this.$route.query.index
                      }
                    });
                  }else{
                    this.$router.push({
                      name: this.$route.query.redirect ,
                    });
                  }
                }else{
                  this.$router.push('/credit-details');
                }
              }else{
                this.loading = false;
                if(response.message != null)
                  this.errors.push(response.message);
              }
            },
            error => {
              this.loading = false;

              if(error.response.data.response.message != undefined)
                this.errors.push(error.response.data.response.message);
              else{
                if(error.response.data.errors.email != undefined)
                  this.errors.push(error.response.data.errors.email[0]);
                if(error.response.data.errors.password != undefined)
                  this.errors.push(error.response.data.errors.password[0]);
              }
            }
          );
        }
      //});
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPassword: function (password) {
      var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;
      return re.test(password);
    },
    goToHomePage() {
      this.$router.push('/');
    },
    goToLogin() {
      this.$router.push('/login');
    },
    goToPrivacyPolicy() {
      let routeData = this.$router.resolve({name: 'PrivacyPolicy'});
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style scoped>
.validationError{
  text-align: left;
  font-size: 12px;
  font-weight: 500;
}

.input-icons i {
	position: absolute;
}
	
.input-icons {
	width: 100%;
	margin-bottom: 10px;
}
	
.icon {
	padding: 18px;
	color: #ababab;
	min-width: 50px;
	text-align: center;
}

.login-header{
	font-size: 24px;
	font-weight: bold;
}

.login-text{
	margin-bottom:30px;
	font-size: 14px;
	color:#666666;
}

.login-page {
  width: 500px;
  padding: 0;
  margin: auto;
}
.form {
  position: relative;
  z-index: 1;
  background: #FFFFFF;
  max-width: 500px;
  margin: auto;
  padding: 45px;
  text-align: center;
  border: 1px solid #ebebeb;
  border-radius: 10px;
}
.form input {
  outline: 0;
  background: #ffffff;
  width: 100%;
  border: 1px solid #ebebeb;
  margin: 0 0 15px;
  padding: 15px 45px;
  box-sizing: border-box;
  font-size: 14px;
  border-radius: 5px;
}
.form button {
font-weight: bold;
  outline: 0;
  background:rgb(55, 147, 233);
  width: 100%;
  border: 0;
  padding: 10px;
  color: #FFFFFF;
  font-size: 14px;
  -webkit-transition: all 0.3 ease;
  transition: all 0.3 ease;
  cursor: pointer;
  border-radius: 5px;
}
.form button:hover,.form button:active,.form button:focus {
  background: rgb(14, 125, 230);
}
.form .message {
  margin: 15px 0 0;
  color: #b3b3b3;
  font-size: 12px;
}
.form .message a {
  color:rgb(55, 147, 233);
  text-decoration: none;
}
.form .register-form {
  display: none;
}
.container {
  position: relative;
  z-index: 1;
  max-width: 300px;
  margin: 0 auto;
}
.container:before, .container:after {
  content: "";
  display: block;
  clear: both;
}
.container .info {
  margin: 50px auto;
  text-align: center;
}
.container .info h1 {
  margin: 0 0 15px;
  padding: 0;
  font-size: 36px;
  font-weight: 300;
  color: #1a1a1a;
}
.container .info span {
  color: #4d4d4d;
  font-size: 12px;
}
.container .info span a {
  color: #000000;
  text-decoration: none;
}
.container .info span .fa {
  color: #EF3B3A;
}
body {
  background: #76b852 !important; /* fallback for old browsers */
  background: -webkit-linear-gradient(right, #76b852, #8DC26F);
  background: -moz-linear-gradient(right, #76b852, #8DC26F);
  background: -o-linear-gradient(right, #76b852, #8DC26F);
  background: linear-gradient(to left, #76b852, #8DC26F);
  font-family: "Roboto", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;      
}

</style>